import { FeaturedCategorySection } from './featured-category-section';

export class ProductDealCarouselSection extends FeaturedCategorySection {}
